import { request } from '../request'

// 获取系统设置暂停时间
export const getSystemSettingSuspendTime = () => request('/portal/common/task/pause-settings')

// 修改系统设置暂停时间
export const updateSystemSettingSuspendTime = data =>
  request('/portal/common/task/pause-settings', { method: 'POST', data })

// 获取任务分组列表
export const getTaskGroups = params => request('/portal/common/task/groups', { params: params })

// 创建任务分组
export const createTaskGroups = data =>
  request('/portal/common/task/groups', { method: 'POST', data })

// 更新任务分组
export const updateTaskGroups = data =>
  request(`/portal/common/task/group/${data.groupId}`, { method: 'PUT', data })

// 删除任务分组
export const deleteTaskGroups = data =>
  request(`/portal/common/task/group/${data.groupId}`, { method: 'DELETE' })
